import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--clients--expenses--dashboard`
    this.setAccountPermission()
  }

  doExpensesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--financials--expenses--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--financials--expenses--save
                                                                                                     operations--products--clinics--financials--expenses--show
                                                                                                     operations--products--clinics--financials--expenses--upload"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--clients--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--clients--show--submenu`).dashboardToggleBtn(`DESPESAS`)

      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--index`).permission = controller.permission
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--show`).permission = controller.permission
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--save`).permission = controller.permission
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--upload`).permission = controller.permission
      
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--financials--expenses--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  setAccountPermission() {
    if (this.application.current_user.account_kind == `admin` || this.application.current_user.account_kind == `team`) {
      this.permission = `medclinic_client_expenses`
    } else if (this.application.current_user.account_kind == `doctor`) {
      this.permission = `medclinic_doctor_client_expenses`
    } else if (this.application.current_user.account_kind == `helper`) {
      this.permission = `medclinic_helper_client_expenses`
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
